import { Action } from '@ngrx/store';

import { User } from '®shared/auth';
import { EditableItem } from '®shared/reading-list';

import { BrokenLinkReport } from './broken-link-report';

export enum ReportBrokenLinkActionTypes {
  HIDE_REPORT_BROKEN_LINK_MODAL = '[Report broken link] Hide modal',
  REPORT_BROKEN_LINK = '[Report broken link] Reporting broken link',
  REPORT_BROKEN_LINK_FAILED = '[Report broken link] Reporting broken link failed',
  REPORT_BROKEN_LINK_SUCCESS = '[Report broken link] Reporting broken link success',
  REPORT_BROKEN_LINK_CANCEL = '[Report broken link] Cancel report broken link',
  SHOW_REPORT_BROKEN_LINK_MODAL = '[Report broken link] Show modal',
}

export interface ReportBrokenLinkPayload {
  item: EditableItem;
  user: User | null;
}

export class ReportBrokenLinkShowModalAction implements Action {
  readonly type = ReportBrokenLinkActionTypes.SHOW_REPORT_BROKEN_LINK_MODAL;

  constructor(public payload: ReportBrokenLinkPayload) {}
}

export class ReportBrokenLinkAction implements Action {
  readonly type = ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK;

  constructor(public payload: { brokenLinkReport: BrokenLinkReport }) {}
}

export class ReportBrokenLinkSuccessAction implements Action {
  readonly type = ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK_SUCCESS;
  constructor(public payload: { brokenLinkReport: BrokenLinkReport }) {}
}

export class ReportBrokenLinkHideModalAction implements Action {
  readonly type = ReportBrokenLinkActionTypes.HIDE_REPORT_BROKEN_LINK_MODAL;
}

export class ReportBrokenLinkCancelAction implements Action {
  readonly type = ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK_CANCEL;
  constructor(public payload: ReportBrokenLinkCancelPayload) {}
}

export interface ReportBrokenLinkFailedPayload {
  error: any;
}

export class ReportBrokenLinkFailedAction implements Action {
  readonly type = ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK_FAILED;

  constructor(public payload: ReportBrokenLinkFailedPayload) {}
}

export interface ReportBrokenLinkCancelPayload {
  itemId: string;
  userAgent: string;
  screenResolution: string;
}

export type ReportBrokenLinkActions =
  | ReportBrokenLinkHideModalAction
  | ReportBrokenLinkAction
  | ReportBrokenLinkSuccessAction
  | ReportBrokenLinkShowModalAction
  | ReportBrokenLinkCancelAction
  | ReportBrokenLinkFailedAction;
